module.exports = __webpack_public_path__ + "static/media/screenshoteye.bd813899.svg";